const {LitElement, html, ref, createRef} = window.globalLit;
import BaseStepElement from './BaseStepElement.js';

customElements.define('wait-step', class WaitStepElement extends BaseStepElement {

    render() {
        return html`
            <strong>Wait for </strong>
                <input is="autogrow-input" type="text" 
                    placeholder="0"
                    .value=${this.value.timeout || ''}
                    ?readonly=${this.readonly}
                    @input="${this._onChange.bind(this, 'timeout')}"
                    style="min-width: 20px; width: 20px;"
                    class="step__input bg-primary-subtle text-primary">
                milliseconds
           `;
    }
});